import { useCallback, useEffect, useState } from "react"
import {
  activatePartnerUser,
  activatePartnerUserByStore,
  authenticatePartner,
  createPartnerStore,
  createStoreAdmin,
  getPartnerApiErrorMessage,
  getStoreActivities,
  resendPartnerVerificationEmail,
  resendPartnerVerificationEmailByStore,
  uploadPartnerStoreProfilePhoto,
} from "../../../services/partnerSignupService"

export const useStoreActivities = () => {
  const [activities, setActivities] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState("")

  const load = useCallback(async () => {
    setLoading(true)
    setError("")
    try {
      setActivities(await getStoreActivities())
    } catch (requestError) {
      setError(getPartnerApiErrorMessage(requestError))
    } finally {
      setLoading(false)
    }
  }, [])

  useEffect(() => {
    load()
  }, [load])

  return { activities, loading, error, reload: load }
}

export const usePartnerSignupApi = () => {
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState("")

  const run = useCallback(async (request, context) => {
    setLoading(true)
    setError("")
    try {
      return await request()
    } catch (requestError) {
      const message = getPartnerApiErrorMessage(requestError, context)
      setError(message)
      throw requestError
    } finally {
      setLoading(false)
    }
  }, [])

  return {
    loading,
    error,
    clearError: () => setError(""),
    createStore: values => run(() => createPartnerStore(values), "store"),
    uploadStoreProfilePhoto: (storeId, image, registrationToken) =>
      run(() => uploadPartnerStoreProfilePhoto(storeId, image, registrationToken), "image"),
    createAdmin: (values, registrationToken) => run(() => createStoreAdmin(values, registrationToken), "user"),
    activateUser: (email, verificationCode) => run(() => activatePartnerUser(email, verificationCode), "activation"),
    activateUserByStore: (storeId, verificationCode) =>
      run(() => activatePartnerUserByStore(storeId, verificationCode), "activation"),
    loginPartner: (email, password) => run(() => authenticatePartner(email, password), "login"),
    resendEmail: email => run(() => resendPartnerVerificationEmail(email), "user"),
    resendEmailByStore: storeId => run(() => resendPartnerVerificationEmailByStore(storeId), "user"),
  }
}
